import React from 'react';
import { Switch, FormLabel, makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';

import { FormTextField, RadioGroupSection } from '../../components';
import styles from './styles';

export default function DynamicForm(props) {
  const { fields, handleChange, index } = props;
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return (
    <div data-apim-test="dynamic-form-container">
      {fields && fields.map((field) =>
        <div key={field.name}>
          {field.type === 'boolean' &&
            <div data-apim-test={field.name} className={classes.fieldContainer}>
              <FormLabel
                className={classes.formLabel}
              >
                {field.name}
              </FormLabel>
              <div>
                No
                <Switch
                  checked={field.value === 'true'}
                  onChange={(e) => handleChange(e.target.checked, field.name, index)}
                />
                Yes
              </div>
            </div>
          }
          {(field.type === 'string' || field.type === 'int') &&
            <FormTextField
              id={field.name}
              name={field.label}
              handleChange={(value) => handleChange(value, field.name, index)}
              value={field.value}
            />
          }
          {field.type === 'radio' &&
            <RadioGroupSection
              id={field.name}
              name={field.label}
              onChange={(e) => handleChange(e.target.value, field.name, index)}
              selected={field.value}
              data={field.data}
            />
          }
        </div>,
      )}
    </div>
  );
}

DynamicForm.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape({})),
  handleChange: PropTypes.func,
  index: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/DynamicForm/index.js